import { Component, Input } from '@angular/core';
import { Audit } from '../../../audit/audit.model';
import {DISPLAY_DATE_FORMAT} from '../../../app.constants';

@Component({
  selector: 'iaud-audit-title',
  templateUrl: './audit-title.component.html',
  styleUrls: ['./audit-title.component.scss'],
})
export class AuditTitleComponent {

  @Input()
  audit: Audit;

  dateFormat: string = DISPLAY_DATE_FORMAT;

}
